import React, { Component } from 'react';
import { size } from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import Tooltip from '@material-ui/core/Tooltip';
import ReactToPrint, { PrintContextConsumer } from "react-to-print";

import './table-water-balance.style.css'



class TableWaterBalance extends Component {
  constructor(props) {
    super(props);


  }

  styleForCol4 = (cell, row, rowIndex, colIndex) => {
    const rowsIndexs = [1, 2]
    if (rowsIndexs.includes(rowIndex)) {
      // return {
      //   backgroundColor: '#B7DEE8'
      // };
      return 'center-col-styleForCol4-bgB7DEE8'
    }
    // return {
    //   backgroundColor: '#DAEEF3'
    // };
    return 'center-col-styleForCol4-bgDAEEF3'
  }

  styleForCol3 = (cell, row, rowIndex, colIndex) => {
    const rowsIndexs = [4, 5, 6, 7]
    if (rowsIndexs.includes(rowIndex)) {
      // return {
      //   backgroundColor: '#B7DEE8'
      // };
      return 'center-col-styleForCol4-bgB7DEE8'
    }
    // return {
    //   backgroundColor: '#DAEEF3'
    // };
    return 'center-col-styleForCol4-bgDAEEF3'
  }

  styleForCol1_2_5 = (cell, row, rowIndex, colIndex) => {
    // return {
    //   backgroundColor: '#DAEEF3'
    // };
    return 'center-col-styleForCol4-bgDAEEF3'
  }

  rowSpanAndHiddenFirstCol = (cell, row, rowIndex, colIndex) => {
    if (rowIndex === 0) {
      return { rowSpan: '8' }
    }
    return ({ hidden: true })
  }

  formatCellFirstCol = (cell, row) => {
    return <div >
      <p className="name-nrw-cell">{cell.name}</p>
      <p className="value-nrw-cell"><strong>{cell.value} m<sup>3</sup>/day</strong></p>
      <p className="percent-nrw-cell"><strong>{cell.percent}</strong></p>
    </div>
  }

  formatCellFourCol = (cell, row) => {
    if (cell.name === 'Billed Metered Consumption' || cell.name === 'System Input Volume') {
      // console.log('cell',cell);
      return <div>
        <p className="name-nrw-cell">{cell.name}</p>
        <p className="value-nrw-cell"><strong>{cell.value} m<sup>3</sup></strong>/day</p>
        <p className="percent-nrw-cell"><strong>{cell.percent}</strong></p>
      </div>
    } else {
      // console.log('cell else',cell);
      return <div>
        <p className="name-nrw-cell">{cell.name}</p>
        <p className="value-nrw-cell"><strong>{cell.value} m<sup>3</sup>day</strong></p>
        <p className="percent-nrw-cell"><strong>{cell.percent}</strong></p>
      </div>
    }
  }

  rowSpanAndHiddenSecondCol = (cell, row, rowIndex, colIndex) => {
    const rowsIndex = [0, 4]
    if (rowsIndex.includes(rowIndex)) {
      return { rowSpan: '4' }
    }
    return ({ hidden: true })
  }

  rowSpanAndHiddenThirdCol = (cell, row, rowIndex, colIndex) => {
    const rowsIndex = [0, 2, 4, 6]
    if (rowsIndex.includes(rowIndex)) {
      return { rowSpan: '2' }
    }
    return ({ hidden: true })
  }

  rowSpanAndHiddenFiveCol = (cell, row, rowIndex, colIndex) => {
    if (rowIndex === 0) {
      return { rowSpan: '2' }
    } else if (rowIndex === 2) {
      return { rowSpan: '6' }
    }
    return ({ hidden: true })
  }

  reorder = (sources, indexs) => {
    try {
      let temp = new Array(sources.length);

      // arr[i] should be present at index[i] index 
      for (let i = 0; i < sources.length; i++)
        temp[indexs[i]] = sources[i];

      // Copy temp[] to arr[] 
      for (let i = 0; i < sources.length; i++) {
        sources[i] = temp[i];
        indexs[i] = i;
      }
      return sources;

    } catch (error) {
      console.log('Error in reorder real loss:', error);
    }
  }

  createData = (dataNRWByDMA) => {
    try {
      if (size(dataNRWByDMA) !== 0) {
        //firstCol
        const systemInputVolume = { name: 'System Input Volume', value: dataNRWByDMA['WATER_SUPPLIED'], percent: `${dataNRWByDMA['PERCENT_WATER_SUPPLIED']}%` }
        //secondCol
        const authorisedConsumption = { name: 'Authorised Consumption', value: dataNRWByDMA['AUTH_CONSUMP'], percent: `${dataNRWByDMA['PERCENT_AUTH_CONSUMP']}%` }
        const waterLosses = { name: 'Water Losses', value: dataNRWByDMA['WATER_LOSSES'], percent: `${dataNRWByDMA['PERCENT_WATER_LOSS']}%` }
        //thirdCol
        const billedAuthoriseConsumption = { name: 'Billed Authorised Consumption', value: dataNRWByDMA['BILL_AUTH_CONSUMP'], percent: `${dataNRWByDMA['PER_BILL_AUTH_CONSUMP']}%` }
        const unbilledAuthorisedConsumption = { name: 'Unbilled Authorised Consumption', value: dataNRWByDMA['UNBILL_AUTH_CONSUMP'], percent: `${dataNRWByDMA['PER_UNBILL_AUTH_CONS']}%` }
        const apparentLosses = { name: 'Apparent Losses', value: dataNRWByDMA['APP_LOSSES'], percent: `${dataNRWByDMA['PER_APP_LOSS']}%` }
        const realLosses = { name: 'Real Losses (Physical Losses)', value: dataNRWByDMA['CUR_AN_REAL_LOSS'], percent: `${dataNRWByDMA['PER_REAL_LOSS']}%` }
        //fourCol
        const billedMeteredConsumption = { name: 'Billed Metered Consumption', value: dataNRWByDMA['BILL_METER_CONSUMP'], percent: `${dataNRWByDMA['PER_BILL_METER_CONS']}%` }
        const billedUnmeteredConsumption = { name: 'Billed Unmetered Consumption', value: dataNRWByDMA['BILL_UNMETER_CONSUMP'], percent: `${dataNRWByDMA['PER_BILL_UNMET_CONS']}%` }
        const unbilledMeteredConsumption = { name: 'Unbilled Metered Consumption (Tanker Supply, elephant trunk, public stand pipe, subsidary min volume usage by utilities)', value: dataNRWByDMA['UNBILL_METER_CONSUMP'], percent: `${dataNRWByDMA['PER_UNBILL_MET_CONS']}%` }
        const unbilledUnmeteredConsumption = { name: 'Unbilled Unmetered Consumption (Illegal usage-available stand meter but no meter)', value: dataNRWByDMA['UNBILL_UNMET_CONS'], percent: `${dataNRWByDMA['PER_UNBILL_UNME_CONS']}%` }
        const unauthorisedConsumption = { name: 'Unauthorised Consumption (Illegal @ theft)', value: dataNRWByDMA['UNAUTH_CONSUMP'], percent: `${dataNRWByDMA['PER_UNAUTH_CONS']}%` }
        const customerMeteringInaccuracies = { name: 'Customer Metering Inaccuracies', value: dataNRWByDMA['CUS_METER_INACCURA'], percent: `${dataNRWByDMA['PER_METER_INACCURA']}%` }
        const leakageTransmission = { name: "Leakage on Transmission and/or Distribution Mains and Leakage and Overflows at Utility's Storage Tanks", value: dataNRWByDMA['LEAK_TRANS'], percent: `${dataNRWByDMA['PER_LEAK_TRANS']}%` }
        const leakageService = { name: 'Leakage on Service Connections Up to Point of Customer Metering', value: dataNRWByDMA['LEAK_SERVICES'], percent: `${dataNRWByDMA['PER_LEAK_SERVICES']}%` }
        //fiveCol
        const revenueWater = { name: "Revenue Water", value: dataNRWByDMA['REVENUE_WATER'], percent: `${dataNRWByDMA['PER_REVENUE_WATER']}%` }
        const nonRevenueWater = { name: 'Non-Revenue Water', value: dataNRWByDMA['NON_REV_WATER_NRW'], percent: `${dataNRWByDMA['PERCENT_NRW']}%` }

        return {
          systemInputVolume, authorisedConsumption, waterLosses, billedAuthoriseConsumption, unbilledAuthorisedConsumption, apparentLosses, realLosses,
          billedMeteredConsumption, billedUnmeteredConsumption, unbilledMeteredConsumption, unbilledUnmeteredConsumption, unauthorisedConsumption,
          customerMeteringInaccuracies, leakageTransmission, leakageService, revenueWater, nonRevenueWater
        }
      } else {
        //firstCol
        const systemInputVolume = { name: 'System Input Volume', value: '0', percent: '0%' }
        //secondCol
        const authorisedConsumption = { name: 'Authorised Consumption', value: '0', percent: '0%' }
        const waterLosses = { name: 'Water Losses', value: '0', percent: '0%' }
        //thirdCol
        const billedAuthoriseConsumption = { name: 'Billed Authorised Consumption', value: '0', percent: '0%' }
        const unbilledAuthorisedConsumption = { name: 'Unbilled Authorised Consumption', value: '0', percent: '0%' }
        const apparentLosses = { name: 'Apparent Losses', value: '0', percent: '0%' }
        const realLosses = { name: 'Real Losses (Physical Losses)', value: '0', percent: '0%' }
        //fourCol
        const billedMeteredConsumption = { name: 'Billed Metered Consumption', value: '0', percent: '0%' }
        const billedUnmeteredConsumption = { name: 'Billed Unmetered Consumption', value: '0', percent: '0%' }
        const unbilledMeteredConsumption = { name: 'Unbilled Metered Consumption (Tanker Supply, elephant trunk, public stand pipe, subsidary min volume usage by utilities)', value: '0', percent: '0%' }
        const unbilledUnmeteredConsumption = { name: 'Unbilled Unmetered Consumption (Illegal usage-available stand meter but no meter)', value: '0', percent: '0%' }
        const unauthorisedConsumption = { name: 'Unauthorised Consumption (Illegal @ theft)', value: '0', percent: '0%' }
        const customerMeteringInaccuracies = { name: 'Customer Metering Inaccuracies', value: '0', percent: '0%' }
        const leakageTransmission = { name: "Leakage on Transmission and/or Distribution Mains and Leakage and Overflows at Utility's Storage Tanks", value: '0', percent: '0%' }
        const leakageService = { name: 'Leakage on Service Connections Up to Point of Customer Metering', value: '0', percent: '0%' }
        //fiveCol
        const revenueWater = { name: "Revenue Water", value: '0', percent: '0%' }
        const nonRevenueWater = { name: 'Non-Revenue Water', value: '0', percent: '0%' }

        return {
          systemInputVolume, authorisedConsumption, waterLosses, billedAuthoriseConsumption, unbilledAuthorisedConsumption, apparentLosses, realLosses,
          billedMeteredConsumption, billedUnmeteredConsumption, unbilledMeteredConsumption, unbilledUnmeteredConsumption, unauthorisedConsumption,
          customerMeteringInaccuracies, leakageTransmission, leakageService, revenueWater, nonRevenueWater
        }
      }
    } catch (error) {
      console.log('Error in create data table water balance: ', error);
    }
  }

  render() {
    const { dataNRWByDMA } = this.props;

    const {
      systemInputVolume, authorisedConsumption, waterLosses, billedAuthoriseConsumption, unbilledAuthorisedConsumption, apparentLosses, realLosses,
      billedMeteredConsumption, billedUnmeteredConsumption, unbilledMeteredConsumption, unbilledUnmeteredConsumption, unauthorisedConsumption,
      customerMeteringInaccuracies, leakageTransmission, leakageService, revenueWater, nonRevenueWater
    } = this.createData(dataNRWByDMA);

    let monthYear = '--';

    if (size(dataNRWByDMA) !== 0) {
      const month = dataNRWByDMA['MONTH'];
      const year = dataNRWByDMA['YEAR'];
      monthYear = `${month}/${year}`;
    }

    const columns = [
      {
        dataField: 'id',
        text: 'ID',
        hidden: true
      }, {
        dataField: 'firstCol',
        text: `IWA Standard International Water Balance and Terminology (${monthYear})`,
        headerAttrs: { colSpan: '5' },
        attrs: this.rowSpanAndHiddenFirstCol,
        formatter: this.formatCellFourCol,
        headerClasses: 'center-header-col',
        // classes: 'center-col',
        classes: this.styleForCol1_2_5
        // style: this.styleForCol1_2_5
      }, {
        dataField: 'secondCol',
        text: '',
        headerAttrs: { hidden: true },
        attrs: this.rowSpanAndHiddenSecondCol,
        formatter: this.formatCellFirstCol,
        // classes: 'center-col',
        classes: this.styleForCol1_2_5,
        // style: this.styleForCol1_2_5
      }, {
        dataField: 'thirdCol',
        text: '',
        headerAttrs: { hidden: true },
        attrs: this.rowSpanAndHiddenThirdCol,
        formatter: this.formatCellFirstCol,
        // classes: 'center-col',
        classes: this.styleForCol3,
        // style: this.styleForCol3
      }, {
        dataField: 'fourCol',
        text: 'Value',
        headerAttrs: { hidden: true },
        formatter: this.formatCellFourCol,
        // classes: 'center-col',
        classes: this.styleForCol4,
        // style: this.styleForCol4
      }, {
        dataField: 'fiveCol',
        text: 'Unit',
        headerAttrs: { hidden: true },
        attrs: this.rowSpanAndHiddenFiveCol,
        formatter: this.formatCellFirstCol,
        // classes: 'center-col',
        classes: this.styleForCol1_2_5
        // style: this.styleForCol1_2_5
      }];
    const products = [
      { id: 1, firstCol: systemInputVolume, secondCol: authorisedConsumption, thirdCol: billedAuthoriseConsumption, fourCol: billedMeteredConsumption, fiveCol: revenueWater },
      { id: 2, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: '', fourCol: billedUnmeteredConsumption, fiveCol: '' },
      { id: 3, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: unbilledAuthorisedConsumption, fourCol: unbilledMeteredConsumption, fiveCol: nonRevenueWater },
      { id: 4, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: '', fourCol: unbilledUnmeteredConsumption, fiveCol: '' },
      { id: 5, firstCol: 'Total Length of Mains', secondCol: waterLosses, thirdCol: apparentLosses, fourCol: unauthorisedConsumption, fiveCol: '' },
      { id: 6, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: '', fourCol: customerMeteringInaccuracies, fiveCol: '' },
      { id: 7, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: realLosses, fourCol: leakageTransmission, fiveCol: '' },
      { id: 8, firstCol: 'Total Length of Mains', secondCol: '', thirdCol: '', fourCol: leakageService, fiveCol: '' }
    ]

    return (
      // style={{overflowY:'auto',height: '350px'}}
      <div>
        <BootstrapTable keyField='id' data={products} columns={columns} wrapperClasses="table-responsive" version='4' />
      </div>
    )
  }
}

class ExportPDFTableWaterBalance extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {/* <ReactToPrint
          trigger={() => <a href="#">Print this out!</a>}
          content={() => this.componentRef}
        /> */}
        <ReactToPrint content={() => this.componentRef} documentTitle="NRW Table">
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <div className="container-export-button-nrw-table">
                <Tooltip title="Print to PDF and more" placement="right" arrow >
                  {/* <Button>Arrow</Button> */}
                  <button className="btn-export-pdf" onClick={handlePrint}><i className="fas fa-print"></i></button>
                </Tooltip>
              </div>
              // <button onClick={handlePrint}>Print this out!</button>
            )}
          </PrintContextConsumer>
        </ReactToPrint>
        <hr />

        {/* <TableWaterBalance
                  data={this.props.data}
                  hasData={this.props.hasData}
                  loadingFillData={this.props.loadingFillData}
                  sendEditValueToParent={this.props.sendEditValueToParent}
                  ref={el => (this.componentRef = el)} /> */}
        <TableWaterBalance dataNRWByDMA={this.props.dataNRWByDMA} ref={el => (this.componentRef = el)}></TableWaterBalance>

      </div>
    );
  }
}

// export default TableWaterBalance
export default ExportPDFTableWaterBalance
